import { render, staticRenderFns } from "./ScribeSummary.vue?vue&type=template&id=dfec525c&"
import script from "./ScribeSummary.vue?vue&type=script&lang=js&"
export * from "./ScribeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports